/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StartDateType = {
    AsSoonAsPossible: 'AS_SOON_AS_POSSIBLE',
    ChosenDate: 'CHOSEN_DATE',
    Unknown: 'UNKNOWN'
} as const;
export type StartDateType = typeof StartDateType[keyof typeof StartDateType];


export function instanceOfStartDateType(value: any): boolean {
    for (const key in StartDateType) {
        if (Object.prototype.hasOwnProperty.call(StartDateType, key)) {
            // @ts-ignore
            if (StartDateType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StartDateTypeFromJSON(json: any): StartDateType {
    return StartDateTypeFromJSONTyped(json, false);
}

export function StartDateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartDateType {
    return json as StartDateType;
}

export function StartDateTypeToJSON(value?: StartDateType | null): any {
    return value as any;
}

